module.exports = __webpack_public_path__ + "static/media/Credits-40.12571806.pdf";